export default __webpack_public_path__ + "static/media/unread-1.ed216707.svg";